export const PLUGIN_ID = 'generate-data';
